import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import constants from '../constants/globalConstants';
//import axios from 'axios';
/** Function to send emails
 * parameters :
 * data in array
 * returns - address URL
 */
var YEXT_ENTITIES_API_URL = "https://liveapi.yext.com/v2/accounts/me/entities";
var YEXT_LOCATION_SEARCH_TOKEN = "2bc9758495549d8bd15fe1c10fdcd617";
var YEXT_API_V = "20190805";
export var sendEmail = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(emailData, action,
  // captcha,
  failureCallback, successCallback) {
    var axios;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('axios');
          case 2:
            axios = _context.sent["default"];
            axios({
              url: action,
              method: 'post',
              data: emailData,
              headers: {
                Accept: 'application/javascript'
              }
            }).then(function (response) {
              if (successCallback) {
                successCallback(response);
              }
              return response;
            })["catch"](function (response) {
              if (failureCallback) {
                failureCallback(response.message);
              }
              return response;
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function sendEmail(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/** Decides whether a form should be redered or not
 * @param {Object} formData - Contains formdata
 * @return {boolean} true: Displays Form, false: no display of form
 */
export var isRenderForm = function isRenderForm(formData) {
  return formData && formData.reCaptchaKey && formData.submitUrl && formData.successfulSubmissionMessage && true || false;
};
var botCheck = function botCheck(field, successCallback) {
  if (field.trim().length > 0) {
    successCallback();
    return false;
  }
  return true;
};

/** Function to fetch search results based on location
 * @parameters locationParams (state, zipCode, pageSize, pageNumber), success handler, error handler
 * @returns response | error
 */
export var findLocations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var state, zipCode, botField, pageSize, pageNumber, yextSearchApi, successCallback, failureCallback, XbusinessType, themeName, businessTypes, _params, url, filterFolder, offset, axios;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = params.state, zipCode = params.postalCode, botField = params.postalCodeField, pageSize = params.pageSize, pageNumber = params.pageNumber, yextSearchApi = params.yextSearchApi, successCallback = params.successCallback, failureCallback = params.failureCallback, XbusinessType = params.XbusinessType, themeName = params.themeName;
            businessTypes = params.businessType;
            businessTypes = businessTypes.join();
            if (!botCheck(botField, successCallback)) {
              _context2.next = 12;
              break;
            }
            _params = {
              state: state,
              zipCode: zipCode,
              businessType: businessTypes,
              pageSize: pageSize,
              pageNumber: pageNumber
            };
            filterFolder = "filter=%7B%22meta.folderId%22%3A%7B%22%24eq%22%3A%22249017%22%7D%7D";
            offset = pageNumber * pageSize - pageSize;
            if (XbusinessType == 'NVA Corporate' && themeName == 'PetSuites') {
              url = "".concat(YEXT_ENTITIES_API_URL, "?api_key=").concat(YEXT_LOCATION_SEARCH_TOKEN, "&v=").concat(YEXT_API_V, "&sortBy=[{\"address.region\":\"ASCENDING\"},{\"name\":\"ASCENDING\"}]&limit=").concat(pageSize, "&offset=").concat(offset, "&").concat(filterFolder, "&fields=address,websiteUrl,name,c_businessType,mainPhone,c_websitePhone,fax,featuredMessage,c_googleMyBusinessCID");
            } else {
              url = "".concat(yextSearchApi).concat(constants.siteGenerator.yextLocationsSearchEndpoint);
            }
            _context2.next = 10;
            return import('axios');
          case 10:
            axios = _context2.sent["default"];
            axios({
              url: "".concat(url),
              method: 'get',
              crossdomain: true,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
              },
              params: _params
            }).then(function (_ref3) {
              var data = _ref3.data;
              if (successCallback) {
                successCallback(data);
              }
            })["catch"](function (errorResponse) {
              if (failureCallback) {
                failureCallback(errorResponse.message);
              }
            });
          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function findLocations(_x5) {
    return _ref2.apply(this, arguments);
  };
}();

/** Function to fetch states list of US and CA
 * @returns response | error
 */
export var fetchStatesList = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var successCallback, failureCallback, yextSearchApi, axios;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            successCallback = params.successCallback, failureCallback = params.failureCallback, yextSearchApi = params.yextSearchApi;
            _context3.next = 3;
            return import('axios');
          case 3:
            axios = _context3.sent["default"];
            axios({
              url: "".concat(yextSearchApi).concat(constants.siteGenerator.yextLocationsEndpoint),
              method: 'get',
              crossdomain: true,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
              }
            }).then(function (_ref5) {
              var data = _ref5.data;
              if (successCallback) {
                successCallback(data);
              }
            })["catch"](function (errorResponse) {
              if (failureCallback) {
                failureCallback(errorResponse);
              }
            });
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function fetchStatesList(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

/** Fetch coordinates for entities from yext api
 * @returns response | error
 */
var getAllLocationsCoordinates = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data, successCallback, filterFolder, state) {
    var count, offset, loops, apiCalls, results, axios, i;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            count = data.response.count;
            offset = 0;
            loops = Math.ceil(count / 50);
            apiCalls = [];
            if (state) {
              filterFolder = "filter=%7B%22address.region%22%3A%7B%22%24eq%22%3A%".concat(state, "%22%7D%7D");
            }
            _context4.next = 7;
            return import('axios');
          case 7:
            axios = _context4.sent["default"];
            for (i = 0; i < loops; i++) {
              apiCalls.push(axios.get("".concat(YEXT_ENTITIES_API_URL, "?api_key=").concat(YEXT_LOCATION_SEARCH_TOKEN, "&v=").concat(YEXT_API_V, "&limit=50&").concat(filterFolder ? filterFolder : '', "&fields=name,yextDisplayCoordinate,address,websiteUrl,mainPhone,fax,featuredMessage,c_googleMyBusinessCID&offset=").concat(offset)));
              offset = offset + 50;
            }
            axios.all([].concat(apiCalls)).then(axios.spread(function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              // TODO: support multiple requests
              //   for (let i = 0; i < args.length; i++) {
              // }
              results = args[0].data;
            })).then(function () {
              if (successCallback) {
                successCallback(results);
              }
            });
          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function getAllLocationsCoordinates(_x7, _x8, _x9, _x10) {
    return _ref6.apply(this, arguments);
  };
}();

/** Fetch coordinates for entities from yext api
 * @returns response | error
 */
export var fetchCoordinates = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var successCallback, failureCallback, businessType, themeName, state, filterFolder, axios;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            // TODO: yext api cal result in different entities for postman/browser, to fix fetch woth state
            successCallback = params.successCallback, failureCallback = params.failureCallback, businessType = params.businessType, themeName = params.themeName, state = params.state;
            if (businessType == 'NVA Corporate' && themeName == 'PetSuites') {
              filterFolder = "filter=%7B%22meta.folderId%22%3A%7B%22%24eq%22%3A%22249017%22%7D%7D";
            }
            if (state) {
              filterFolder = "filter=%7B%22address.region%22%3A%7B%22%24eq%22%3A%".concat(state, "%22%7D%7D");
            }
            _context5.next = 5;
            return import('axios');
          case 5:
            axios = _context5.sent["default"];
            axios({
              url: "".concat(YEXT_ENTITIES_API_URL, "?api_key=").concat(YEXT_LOCATION_SEARCH_TOKEN, "&v=").concat(YEXT_API_V, "&limit=50&").concat(filterFolder ? filterFolder : '', "&fields=name"),
              method: 'get',
              crossdomain: true,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache'
              }
            }).then(function (_ref8) {
              var data = _ref8.data;
              getAllLocationsCoordinates(data, successCallback, filterFolder, state);
            })["catch"](function (errorResponse) {
              if (failureCallback) {
                failureCallback(errorResponse);
              }
            });
          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function fetchCoordinates(_x11) {
    return _ref7.apply(this, arguments);
  };
}();